import { Text, useStyleConfig } from '@tectonic/elemason-components';
import clsx from 'clsx';
import { useAccessorValue } from '../../hooks/useAccessorValue';

import type {
  ElemasonProductAttributesWidget,
  ProductDisplayAttribute,
} from '@tectonic/types';
import type { FC } from 'react';

interface ElemasonProductAttributesWidgetProps {
  widget: ElemasonProductAttributesWidget;
}

const ProductAttributesWidget: FC<ElemasonProductAttributesWidgetProps> = ({
  widget: { config, data },
}) => {
  const { className: contClassName, style: contStyle } = useStyleConfig(
    config?.container ?? {}
  );

  const { className: listClassName, style: listStyle } = useStyleConfig(
    config?.list ?? {}
  );

  // TODO some reason the width is not coming up in the below config, hence setting it manually
  const { className: attrNameContClassName, style: attrNameContStyle } =
    useStyleConfig(config?.attrName?.container ?? {});

  const { className: attrValContClassName, style: attrValContStyle } =
    useStyleConfig(config?.attrValue?.container ?? {});

  const productAttributes: ProductDisplayAttribute[] =
    useAccessorValue(data?.attributes ?? {}) || [];

  if (productAttributes.length === 0) {
    return null;
  }

  return (
    <div className={clsx('flex flex-col', contClassName)} style={contStyle}>
      <div className={clsx('flex flex-col', listClassName)} style={listStyle}>
        {productAttributes.map((productAttribute) => {
          const allValues = productAttribute.values
            .map((val) => val.name)
            .join(', ');
          return (
            <div
              key={`product-attr-${productAttribute.slug}`}
              className={clsx('flex flex-row')}
            >
              <div
                className={clsx('flex flex-col', attrNameContClassName)}
                style={{ ...attrNameContStyle, maxWidth: '148px', flex: 1 }}
              >
                <Text
                  config={config?.attrName?.text}
                  data={productAttribute.name}
                />
              </div>
              <div
                className={clsx('flex flex-col', attrValContClassName)}
                style={{ ...attrValContStyle, flex: 1 }}
              >
                <Text config={config?.attrValue?.text} data={allValues} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export { ProductAttributesWidget };
